/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T09:38:27.831
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveCCBContract,
	getCCBContractCreateInit,
	getCCBContractEditInit,
	getCCBContractView,
	deleteCCBContract
} from '@api/house/CCBContract';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

import {
listCCBContractFeesInit,
listCCBContractFeesByAuthorizations,
deleteCCBContractFees
} from '@api/house/CCBContractFees';

import {
listCCBSyncLogInit,
listCCBSyncLogByAuthorizations,
deleteCCBSyncLog
} from '@api/house/CCBSyncLog';

export default {
	namespaced: true,

	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getCCBContractCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBContractEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveCCBContract({}, CCBContract) {
			return new Promise((resolve, reject) => {
				saveCCBContract(CCBContract)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBContractView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteCCBContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteCCBContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
